export default {
  // 编辑
  updateYxOutboundOrder: '/ygsjzs/yxOutboundOrder/updateYxOutboundOrder',
  // 详情
  selectYxOutboundOrderByOutboundId: '/ygsjzs/yxOutboundOrder/selectYxOutboundOrderByOutboundId',
  // 分页列表
  selectYxOutboundOrderByPage: '/ygsjzs/yxOutboundOrder/selectYxOutboundOrderByPage',
  // 导出
  exportYxOutboundOrder: '/ygsjzs/yxOutboundOrder/exportYxOutboundOrder'
}
